import React, { useState, useEffect, useRef } from "react";
import { ListFinance } from "../../../Utility/Api";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toast } from "react-toastify";
import { NaviGate, numberToWords } from "../../../Utility/function";

const FinanceList = () => {
  const [Order, setOder] = useState([]);
  const [FilterOrder, setFilterOrder] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState([]);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const modalContentRef = useRef(null);
  const [OrderList, setOrderList] = useState([]);

  useEffect(() => {
    fetchOrders();
  }, []);
  const fetchOrders = async () => {
    try {
      const response = await ListFinance();
      if (response.data && response.data.data) {
        const product = response.data.data;
        setOder(product);
        setFilterOrder(product);
      }
    } catch (error) {
      console.error("Error fetching Customer data:", error);
    }
  };

  const formatPrice = (price) =>
    !isNaN(Number(price)) ? Number(price).toFixed(3) : "0.0";

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedInvoice([]);
  };
  // all data storeed this state
  const [selecteddata, setselecteddata] = useState();

  // const handleViewClick = async (data) => {
  //   console.log(JSON.parse(data.data));
  //   console.log(data);
  //   setselecteddata(data)
  //   setShowModal(true);
  // };

  const [newpurchasequtation, setnewpurchasequtation] = useState({});
  const handleViewClick = async (data) => {
    const parsedData = data;
    setselecteddata(data);
    console.log(JSON.parse(data.data));

    setSelectedInvoice(JSON.parse(data.data)); // Set the selected invoice to state

    const idPrefix = data.im_unique_id?.slice(0, 2).toUpperCase();
    console.log(typeof idPrefix);

    let customerDetails = {};
    if (idPrefix === "PO") {
      customerDetails = {
        name: parsedData.supplier_name,
        email: parsedData.supplier_email,
        address: parsedData.supplier_address,
        phone: parsedData.supplier_phone,
        id: parsedData.im_unique_id,
        date: parsedData.latest_date,
      };
      console.log(customerDetails);
      setnewpurchasequtation(customerDetails);
    } else if (idPrefix === "QU" || idPrefix === "SW") {
      customerDetails = {
        name: parsedData.customer_name,
        email: parsedData.customer_email,
        address: parsedData.customer_country,
        phone: parsedData.customer_phone,
        id: parsedData.im_unique_id,
        date: parsedData.latest_date,
      };
      setnewpurchasequtation(customerDetails);
    }

    // setSelectedInvoice({
    //   items: parsedData.items || [],
    //   customerDetails,
    //   invoiceDetails: {
    //     invoiceNo: data.invoice_no || "",
    //     date: data.date || "",
    // },
    // });

    setShowModal(true);
  };

  const handleChange = async (e) => {
    const { value } = e.target;
    setFilterOrder(
      Order.filter(
        (item) =>
          item.im_unique_id &&
          item.im_unique_id.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const handleDownload = async () => {
    const content = modalContentRef.current;

    if (content) {
      try {
        const canvas = await html2canvas(content, {
          scale: 2,
        });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("invoice.pdf");
        toast.success("file downloaded successfully");
      } catch (error) {
        console.error("Failed to download the PDF:", error);
      }
    } else {
      console.error("Modal content not found for PDF download");
    }
  };

  const handlePrint = async () => {
    const content = modalContentRef.current; // Reference to modal content

    if (!content) {
      console.error("Modal content not found for printing");
      return;
    }

    try {
      const canvas = await html2canvas(content, {
        scale: 2,
      });

      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      const pdfBlob = pdf.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);

      const printWindow = window.open(pdfUrl, "_blank");

      if (printWindow) {
        printWindow.print();
      } else {
        console.error("Failed to open the print window");
      }

      URL.revokeObjectURL(pdfUrl);
    } catch (error) {
      console.error("Failed to generate or print the PDF:", error);
    }
  };

  const handleShare = (platform) => {
    const message = encodeURIComponent("Check out this amazing content!");
    const url = encodeURIComponent(window.location.href);

    if (platform === "WhatsApp") {
      window.open(`https://wa.me/?text=${message} ${url}`, "_blank");
    } else if (platform === "Skype") {
      window.open(
        `https://web.skype.com/share?url=${url}&text=${message}`,
        "_blank"
      );
    } else if (platform === "Email") {
      window.location.href = `mailto:?subject=Check out this content&body=${message} ${url}`;
    } else if (platform === "LinkedIn") {
      window.open(
        `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
        "_blank"
      );
    } else {
      alert(`Sharing via ${platform}`);
    }
  };
  // const idPrefix1 = newpurchasequtation?.im_unique_id?.slice(0, 2).toUpperCase();

  return (
    <div className="page-wrappers">
      <div className="page-content py-1">
        <NaviGate/>
        <h6 className="mt-3 text-uppercase">Finance List</h6>
        <hr />
        <div className="d-flex justify-content-end w-100">
          <select onChange={handleChange}>
            <option value="" key="">
              Select Option
            </option>
            <option value="PO" key="">
              Purchase
            </option>
            <option value="QU" key="">
              Quotation
            </option>
            <option value="SW" key="">
              Sales
            </option>
          </select>
        </div>
        <div
          className="table-responsive text-center my-1 w-100 position-relative"
          style={{ overflowX: "hidden", minHeight: "70vh" }}
        >
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Entry ID</th>
                <th>Date</th>
                <th>User (c/s)</th>
                <th>Unit Price</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {FilterOrder &&
                FilterOrder.filter((item) => item.quantities).map(
                  (item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item.im_unique_id}</td>
                      <td>{item.latest_date}</td>
                      <td>
                        {item.supplier_name}
                        {item.customer_name}
                      </td>
                      <td>{formatPrice(parseInt(item.total_amount))}</td>
                      <td>
                        <img
                          src="/assets/images/icons/view.png"
                          alt="View"
                          onClick={() => {
                            handleViewClick(item);
                          }}
                          height={"16px"}
                          style={{ cursor: "pointer" }}
                        />
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>

        {showShareModal && (
          <div
            className="modal show d-block"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block " }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Share via</h5>
                  <button
                    type="button"
                    className=" btn-close"
                    data-dismiss="modal"
                    onClick={() => setShowShareModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <button
                    type="button"
                    className="btn btn-success mb-2 d-flex col-4 align-items-center"
                    onClick={() => handleShare("WhatsApp")}
                  >
                    <i
                      className="bi bi-whatsapp"
                      style={{ color: "white", marginRight: "8px" }}
                    ></i>
                    WhatsApp
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary mb-2 d-flex col-4 align-items-center"
                    onClick={() => handleShare("LinkedIn")}
                  >
                    <i
                      className="bi bi-linkedin"
                      style={{ color: "white", marginRight: "8px" }}
                    ></i>
                    LinkedIn
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger mb-2 d-flex col-4 align-items-center"
                    onClick={() => handleShare("Email")}
                  >
                    <i
                      className="bi bi-envelope"
                      style={{ color: "white", marginRight: "8px" }}
                    ></i>
                    Email
                  </button>
                  <button
                    type="button"
                    className="btn btn-info mb-2 d-flex col-4 align-items-center"
                    onClick={() => handleShare("Skype")}
                  >
                    <i
                      className="bi bi-skype"
                      style={{ color: "white", marginRight: "8px" }}
                    ></i>
                    Skype
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div
          className={`modal fade ${showModal ? "show" : ""}`}
          tabIndex={-1}
          role="dialog"
          style={{ display: showModal ? "block" : "none" }}
          aria-hidden={!showModal}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="" ref={modalContentRef}>
                <div className="modal-header border-0 pb-0">
                  <button
                    type="button"
                    className="btn-close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={handleCloseModal}
                  ></button>
                </div>
                <div className="row mx-3 mt-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="col-md-1">
                      <img
                        src="assets/images/tech_logo.webp"
                        alt="Left Logo"
                        style={{ maxHeight: "38px" }}
                      />
                    </div>

                    <div>
                      <img
                        src="assets/images/arabic.jpg"
                        alt="Left Logo"
                        style={{ maxHeight: "38px" }}
                      />
                    </div>
                  </div>

                  <div className="col-12 text-center mt-2">
                    <p className="fw-bold font-14 mb-0">
                      P.O. Box 605/512, AL Khoudh Souq, Muscat, Sultanate of
                      Oman
                    </p>
                    <p className="fw-medium font-13 mb-0">
                      Mobile: +968 91120555 | E-Mail: Sales@toptecno.com |
                      www.toptecno.com
                    </p>
                  </div>
                </div>
                {/* Invoice Title */}
                <div className="row">
                  <div className="col text-center">
                    <h3
                      className="fw-bold mt-2"
                      style={{ textDecoration: "underline" }}
                    >
                      فاتورة
                    </h3>
                    <h3 className="fw-bold">INVOICE</h3>
                  </div>
                </div>

                <div className="row border-top border-bottom pt-3  mx-3 pb-2">
                  <div className="col-6">
                    <div
                      className="p-2 "
                      style={{
                        border: ".8px solid #dee2e6",
                        minHeight: 150,
                      }}
                    >
                      <h6 className="fw-bold ">
                        {newpurchasequtation?.id?.slice(0, 2).toUpperCase() === "PO"
                          ? "Supplier Details:"
                          : "Customer Details:"}
                      </h6>
                      <div className="d-flex justify-content-between mt-3">
                        <p className="fw-medium font-13 mb-1">Name:</p>
                        <p
                          className="fw-bold font-13 mb-1"
                          style={{ textDecoration: "underline" }}
                        >
                          {newpurchasequtation?.name || ""}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="fw-medium font-13 mb-1">Email:</p>
                        <p
                          className="fw-bold font-13 mb-1"
                          style={{ textDecoration: "underline" }}
                        >
                          {newpurchasequtation?.email || ""}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="fw-medium font-13 mb-1">Address:</p>
                        <p
                          className="fw-bold font-13 mb-1"
                          style={{ textDecoration: "underline" }}
                        >
                          {newpurchasequtation?.address || ""}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="fw-medium font-13 mb-1">Phone:</p>
                        <p
                          className="fw-bold font-13 mb-1"
                          style={{ textDecoration: "underline" }}
                        >
                          {newpurchasequtation?.phone || ""}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <table className="table  table-bordered text-center align-middle m-0 ">
                      <tbody>
                        <tr>
                          <td className="text-start fw-bold">Invoice No:{newpurchasequtation?.id}</td>
                          <td className="text-start fw-bold">Date: {newpurchasequtation?.date}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table className="table table-bordered text-center align-middle">
                      <tbody>
                        <tr>
                          <td className="text-start d-flex flex-row">
                            <p
                              className="fw-bold text-start mb-0"
                              style={{ width: "40%" }}
                            >
                              L.P.O No:{" "}
                            </p>
                            <p
                              className="text-start mb-0"
                              style={{ width: "60%" }}
                            >
                              {" "}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-start d-flex flex-row">
                            <p
                              className="fw-bold text-start mb-0"
                              style={{ width: "40%" }}
                            >
                              Sales Person:{" "}
                            </p>
                            <p
                              className="text-start mb-0"
                              style={{ width: "60%" }}
                            >
                              {" "}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-start d-flex flex-row">
                            <p
                              className="fw-bold text-start mb-0"
                              style={{ width: "40%" }}
                            >
                              Payment Terms:{" "}
                            </p>
                            <p
                              className="text-start mb-0"
                              style={{ width: "60%" }}
                            >
                              {" "}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row mt-4 mx-4">
                <div
            className="row p-3"
            style={{
              position: "relative",
              overflow: "hidden",
              background: `linear-gradient(to bottom, rgba(255, 255, 255, 90%), rgba(255, 255, 255, 90%)), url(assets/images/tech_logo.webp) no-repeat center center / cover`,
              backgroundSize: "60%",
              backgroundPosition: "center",
            }}
          >
                    <div className="table-responsive">
                      <table className=" border table-sm table-bordered w-100">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: "10%" }}>
                              <span>الرقم</span>
                              <br />
                              Sl. No.
                            </th>
                            <th style={{ width: "40%" }}>
                              <span>التفاصيل</span>
                              <br />
                              Particulars
                            </th>
                            <th style={{ width: "15%" }}>
                              <span>الكمية</span>
                              <br />
                              Qty
                            </th>
                            <th style={{ width: "15%" }}>
                              <span>سعر الوحدة</span>
                              <br />
                              Unit Price
                            </th>
                            <th style={{ width: "20%" }}>
                              <span>المبلغ الإجمالي</span>
                              <br />
                              Total Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(selectedInvoice) &&
                            selectedInvoice.map((item, index) => {
                              const unitPrice =
                                newpurchasequtation?.id?.slice(0, 2).toUpperCase() == "PO"
                                  ? parseFloat(item?.purchase_price)
                                  : parseFloat(item?.sales_price);
                              const total = unitPrice * (parseFloat(item.qty) || 0);
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.product_name || "N/A"}</td>
                                  <td>{item.qty || "0"}</td>
                                  <td>{unitPrice.toFixed(3)}</td>
                                  <td>{total.toFixed(3)}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                        <tfoot>
                          <tr><br/></tr>
                          <tr>
                            <td className="bg-transparent"></td>
                            <td className="bg-transparent"></td>
                            <td className="bg-transparent"></td>
                            <td className="bg-transparent fw-bold text-end">
                              Total
                            </td>
                            <td className="bg-transparent">
                              {selectedInvoice
                                .reduce((acc, item) => {
                                  const unitPrice =
                                    newpurchasequtation?.id
                                      ?.slice(0)
                                      .toUpperCase() === "PO"
                                      ? parseFloat(item?.purchase_price)
                                      : parseFloat(item?.sales_price);
                                  return (
                                    acc +
                                    unitPrice * (parseFloat(item.qty) || 0)
                                  );
                                }, 0)
                                .toFixed()}
                            </td>
                          </tr>
                          <tr>
                            <td className="bg-transparent"></td>
                            <td className="bg-transparent"></td>
                            <td className="bg-transparent"></td>
                            <td className="bg-transparent fw-bold text-end">
                              Discount
                            </td>
                            <td className="bg-transparent">
                              {"00.00"}
                            </td>
                          </tr>
                          <tr>
                            <td className="bg-transparent"></td>
                            <td className="bg-transparent"></td>
                            <td className="bg-transparent"></td>
                            <td className="bg-transparent fw-bold text-end">
                              Tax
                            </td>
                            <td className="bg-transparent">
                              {"00.00" }
                            </td>
                          </tr>

                          <tr>
                            <td className="bg-transparent"></td>
                            <td className="bg-transparent"></td>
                            <td className="bg-transparent"></td>
                            <td className="bg-transparent fw-bold text-end">Grand Total</td>
                            <td className="bg-transparent">
                              {selectedInvoice
                                .reduce((acc, item) => {
                                  const unitPrice =
                                    newpurchasequtation?.id
                                      ?.slice(0, 2)
                                      .toUpperCase() === "PO"
                                      ? parseFloat(item?.purchase_price) || 0
                                      : parseFloat(item?.sales_price) || 0;

                                  const total =
                                    unitPrice * (parseFloat(item.qty) || 0);

                                  return acc + total;
                                }, 0)
                                .toFixed(3)}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                      <table className="table table-bordered text-center align-middle mt-0 bg-transparent">
                        <tbody className="bg-transparent">
                          <tr className="bg-transparent">
                            <td className="text-start bg-transparent">
                              <p className="fw-bold text-start mb-0 w-100">
                                Amount In Words:
                                {numberToWords(
                                  Math.floor(
                                    selectedInvoice
                                      .reduce((acc, item) => {
                                        const unitPrice =
                                          newpurchasequtation?.id
                                            ?.slice(0, 2)
                                            .toUpperCase() === "PO"
                                            ? parseFloat(
                                                item?.purchase_price
                                              ) || 0
                                            : parseFloat(item?.sales_price) ||
                                              0;

                                        const total =
                                          unitPrice *
                                          (parseFloat(item.qty) || 0);

                                        return acc + total;
                                      }, 0)
                                      .toFixed(3)
                                  )
                                )}
                                . Riyal Only.{" "}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="row border-top border-bottom py-3 mx-3">
                  <div className="col-4">
                    <div
                      className="p-2"
                      style={{
                        border: ".8px solid #dee2e6",
                        minHeight: 150,
                      }}
                    >
                      <h6 className="fw-bold">Terms & Condition:</h6>
                    </div>
                  </div>
                  <div className="col-4">
                    <div
                      className="p-2"
                      style={{
                        border: ".8px solid #dee2e6",
                        minHeight: 150,
                      }}
                    >
                      <h6 className="fw-bold">Bank Account:</h6>
                    </div>
                  </div>
                  <div className="col-4">
                    <div
                      className="p-2"
                      style={{
                        border: ".8px solid #dee2e6",
                        minHeight: 150,
                      }}
                    >
                      <h6 className="fw-bold">For Top Tecno</h6>
                    </div>
                  </div>
                </div>
              </div>

              {/* Modal Footer with buttons */}
              <div className="modal-footer mx-1 mt-4">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleDownload}
                >
                  Download
                </button>
                <button
                  type="button"
                  className="btn btn-info"
                  onClick={handlePrint}
                >
                  Print
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => setShowShareModal(true)}
                >
                  Share
                </button>

                {showShareModal && (
                  <div
                    className="modal show d-block"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block " }}
                  >
                    <div
                      className="modal-dialog modal-dialog-centered"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Share via</h5>
                          <button
                            type="button"
                            className=" btn-close"
                            data-dismiss="modal"
                            onClick={() => setShowShareModal(false)}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <button
                            type="button"
                            className="btn btn-success mb-2 d-flex col-4 align-items-center"
                            onClick={() => handleShare("WhatsApp")}
                          >
                            <i
                              className="bi bi-whatsapp"
                              style={{ color: "white", marginRight: "8px" }}
                            ></i>
                            WhatsApp
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary mb-2 d-flex col-4 align-items-center"
                            onClick={() => handleShare("LinkedIn")}
                          >
                            <i
                              className="bi bi-linkedin"
                              style={{ color: "white", marginRight: "8px" }}
                            ></i>
                            LinkedIn
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger mb-2 d-flex col-4 align-items-center"
                            onClick={() => handleShare("Email")}
                          >
                            <i
                              className="bi bi-envelope"
                              style={{ color: "white", marginRight: "8px" }}
                            ></i>
                            Email
                          </button>
                          <button
                            type="button"
                            className="btn btn-info mb-2 d-flex col-4 align-items-center"
                            onClick={() => handleShare("Skype")}
                          >
                            <i className="bi bi-skype"
                              style={{ color: "white", marginRight: "8px" }}
                            >
                            </i>
                            Skype
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinanceList;
